<template>
    <div class="row">
        <div v-if="!maximize" class="col-lg-3">
            <b-card>
                <app-timeline>
                    <app-timeline-item 
                        v-for="(item,i) in items" :key="i" 
                        :time="item.time"
                        :title="item.title"
                        :subtitle="item.subtitle"
                        :icon="getIcon(i)"
                        :title-class="i == current ? `font-weight-bolder text-secondary`: null"
                        :variant="getVariant(i)" />
                </app-timeline>
            </b-card>           
        </div>
        <div :class="!maximize ? 'col-lg-9' : 'col-12'">
            <b-card no-body class="p-1 mb-1">
                <div class="row align-items-center">
                    <div class="col-auto border-right">
                        <button class="btn btn-outline-dark btn-icon" v-b-tooltip.bottom.hover="!maximize ? 'Genişlet' : 'Daralt'" v-on:click="maximize = !maximize">
                            <feather-icon v-if="!maximize" icon="MaximizeIcon"></feather-icon>
                            <feather-icon v-else icon="MinimizeIcon"></feather-icon>
                        </button>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.month" :disabled="current > 0">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.year" :disabled="current > 0">
                            <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                        </select>
                    </div>
                    <div class="col-md-5 mb-1 mb-md-0">
                        <v-select-list :options="employeeSalaryGroups" label="Value" v-model="employeeSalaryGroupId" :disabled="current > 0" placeholder="Tüm Maaş Grupları"></v-select-list>
                    </div>
                </div>
            </b-card>

            <template v-if="current == 0">
                <calculate-salary-process-luca-upload-bordro 
                    :donem="donem"
                    :filter="filter"
                    v-on:next="next(1)">
                </calculate-salary-process-luca-upload-bordro>
            </template>
            <template v-if="current == 1">
                <calculate-salary-process-levy-bes 
                    sira="2" 
                    :donem="donem"
                    :filter="filter"
                    :salary-payment-date="salaryPaymentDate"
                    v-on:salary-payment-date="$e => salaryPaymentDate = $e"
                    v-on:next="next(2)" 
                    v-on:back="back(0)"
                ></calculate-salary-process-levy-bes>
            </template>
            <template v-if="current == 2">
                <calculate-salary-process-levy-lock
                    :donem="donem"
                    :filter="filter"
                    :salary-payment-date="salaryPaymentDate"
                    v-on:salary-payment-date="$e => salaryPaymentDate = $e"
                    v-on:next="next(3)" 
                    v-on:back="back(1)"
                ></calculate-salary-process-levy-lock>
            </template>
            <template v-if="current == 3">
                <calculate-salary-process-levy-payment
                    :donem="donem"
                    :filter="filter"
                    v-on:next="next(4)" 
                    v-on:back="back(2)"
                ></calculate-salary-process-levy-payment>
            </template>
            <!-- <template v-if="current == 3">
                <calculate-salary-process-bes-upload 
                v-on:next="next(4)" 
                v-on:back="back(2)"/>
            </template> -->
            <template v-if="current == 4">
                <calculate-salary-process-levy-bes 
                    sira="13" 
                    :donem="donem"
                    :filter="filter"
                    :salary-payment-date="salaryPaymentDate"
                    v-on:salary-payment-date="$e => salaryPaymentDate = $e"
                    v-on:next="next(5)" 
                    v-on:back="back(3)"
                ></calculate-salary-process-levy-bes>
            </template>
            <template v-if="current == 5">
                <calculate-salary-process-bes-lock
                    :donem="donem"
                    :filter="filter"
                    :salary-payment-date="salaryPaymentDate"
                    v-on:salary-payment-date="$e => salaryPaymentDate = $e"
                    v-on:next="next(6)" 
                    v-on:back="back(4)"
                ></calculate-salary-process-bes-lock>
            </template>
            <template v-if="current == 6">
                <calculate-salary-process-result-for-luca 
                    :donem="donem" 
                    :filter="filter"
                    v-on:next="next(7)" 
                    v-on:back="back(5)">
                </calculate-salary-process-result-for-luca>
            </template>
            <template v-if="current == 7">
                <calculate-salary-process-confirmed
                    :donem="donem" 
                    :filter="filter"
                    v-on:back="back(6)"
                ></calculate-salary-process-confirmed>
            </template>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { BCard,VBTooltip } from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import CalculateSalaryProcessLucaUploadBordro from './components/CalculateSalaryProcessLucaUploadBordro.vue';
import CalculateSalaryProcessResultForLuca from './components/CalculateSalaryProcessResultForLuca.vue';
import EmployeeOperationsApi from '@/api/employee-operations'
import CalculateSalaryProcessLevyBes from './components/CalculateSalaryProcessLevyBes.vue'
import CalculateSalaryProcessBesUpload from './components/bes/CalculateSalaryProcessBesUpload.vue'
import CalculateSalaryProcessConfirmed from './components/CalculateSalaryProcessConfirmed.vue';
import CalculateSalaryProcessLevyPayment from './components/CalculateSalaryProcessLevyPayment.vue';
import CalculateSalaryProcessLevyLock from './components/CalculateSalaryProcessLevyLock.vue';
import CalculateSalaryProcessBesLock from './components/CalculateSalaryProcessBesLock.vue';

export default {
    components:{
        BCard,
        AppTimeline,
        AppTimelineItem,
        CalculateSalaryProcessLucaUploadBordro,
        CalculateSalaryProcessResultForLuca,
        CalculateSalaryProcessLevyBes,
        CalculateSalaryProcessBesUpload,
        CalculateSalaryProcessConfirmed,
        CalculateSalaryProcessLevyPayment,
        CalculateSalaryProcessLevyLock,
        CalculateSalaryProcessBesLock
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    data(){
        return {
            current:0,
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            salaryPaymentDate:null,
            maximize:false,
            items:[
                {time:'1',title:'Luca Ücret Bordrosu Yükleme',subtitle:'Luca Ücret Bordrosu tablosunu sisteme yükleyin.'},
                {time:'2',title:'İcra Hesaplama',subtitle:'Tüm personellerin icra tutarlarını hesaplayın.'},
                {time:'3',title:'İcra Onaylama',subtitle:'Tüm personellerin icra tutarlarını onaylayın.'},
                {time:'4',title:'İcra Ödeme Tablosu',subtitle:'Brüt maaşlı personellerin icra tutarlarını hesaplayın.'},
                {time:'5',title:'BES Hesaplama',subtitle:'BES\'e dahil personellerin BES kesinti tutarlarını hesaplayın.'},
                {time:'6',title:'BES Onaylama',subtitle:'BES\'e dahil personellerin BES kesinti tutarlarını hesaplayın.'},
                {time:'7',title:'Hakediş Hesaplama',subtitle:'Girilen tüm veriler tamamlandıktan sonra ödenecek maaş hakedişlerini hesaplayın ve tutarları onaylayın.'},
                {time:'8',title:'Maaş Kilidi',subtitle:'Tutarları onaylanmış maaşları son kez gözden geçirin ve kilitleyerek ödeme emri oluşturulmak üzere finans birimine gönderin.'},
            ],
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            employeeSalaryGroups:[],
            employeeSalaryGroupId:null
        }
    },
    mounted(){
        this.configureYears()
        this.getEmployeeSalaryGroups()
    },
    methods:{
        getIcon(i){
            if(this.current == i){
                return 'ArrowRightCircleIcon'
            } else if(this.current > i){
                return 'CheckCircleIcon'
            } else return 'AlertOctagonIcon'
        },
        getVariant(i){
            if(this.current == i){
                return 'secondary'
            } else if(this.current > i){
                return 'success'
            } else return 'dark'
        },
        next(i){
            this.current = i
            window.scrollTo({top: 0, behavior: 'smooth'})
        },
        back(i){
            this.current = i
            window.scrollTo({top: 0, behavior: 'smooth'})
        },
        getEmployeeSalaryGroups(){
            EmployeeOperationsApi.SalaryGroup.List().then(res=>{
                this.employeeSalaryGroups = res.data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
    },
    computed:{
        filter(){
            return {
                EmployeeSalaryGroupId:this.employeeSalaryGroupId?.Key||null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        }
    }
}
</script>